import Gallery from './Gallery'
import Image from './Image'
import { handleToggleModal } from './Functions'
import React from 'react'

const Results = ({ setState, state, varNames }) => {
  return (
    <div className='photos-search-result'>
      <Gallery>
        {(() => {
          const start = (state.page - 1) * 60
          let end = state.page * 60

          if (end > state.items.length) {
            end = state.items.length
          }
          if (state.isAdmin) {
            /** console.log('Page, Start, End: ', state.page, start, end) */
          }
          return (
            state.items.slice(start, end).map((o, j, k) => (
              <Image onClick={() => handleToggleModal(j, k)} key={o.id}>
                <img
                  alt={o.title}
                  src={(() => {
                    const parts = o.url.replace('-scaled', '').split('.')
                    parts[parts.length - 2] += '-150x150'
                    return parts.join('.')
                  })()}
                  className='photos-gallery-thumbnail'
                />
                <img
                  alt={o.title}
                  src={o.url}
                  className='photos-gallery-photo'
                  hidden
                />
              </Image>
            ))
          )
        })()}
      </Gallery>
    </div>
  )
}

export default Results
